<template>
  <div v-if="!loading" class="w-full">
    <CustomizationsV2 />
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";

import CustomizationsV2 from "./v2/Customizations.vue";

const store = useStore();
const loading = computed(() => {
  return !store.state.tenant;
});
</script>
